export const REQUESTED_TYPE_ERROR = 'All requested offer types are not allowed by dealer settings for the vehicle';

export class RequestedPaymentTypeError extends Error {
    constructor() {
        super(REQUESTED_TYPE_ERROR);
    }
}
